import { render, staticRenderFns } from "./FactorScoreRule.vue?vue&type=template&id=441640d2&"
import script from "./FactorScoreRule.vue?vue&type=script&lang=ts&"
export * from "./FactorScoreRule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports